export const navLinksdata = [
    {
        _id: 1001,
        title: "Home",
        link: "home",
    },
    {
        _id: 1002,
        title: "Features",
        link: "features",
    },
    // {
    //     _id: 1003,
    //     title: "Qualification",
    //     link: "qualification",
    // },
    // {
    //     _id: 1004,
    //     title: "Skills",
    //     link: "skills",
    // },
    {
        _id: 1005,
        title: "Projects",
        link: "projects",
    },
    {
        _id: 1006,
        title: "Resume",
        link: "resume",
    },
    {
        _id: 1007,
        title: "Contact",
        link: "contact",
    },
]


export const FooterLink = [
    {
        _id: 1001,
        title: "Home",
        link: "home",
    },
    {
        _id: 1002,
        title: "Features",
        link: "features",
    },
    // {
    //     _id: 1003,
    //     title: "Qualification",
    //     link: "qualification",
    // },
    // {
    //     _id: 1004,
    //     title: "Skills",
    //     link: "skills",
    // },
    {
        _id: 1005,
        title: "Projects",
        link: "projects",
    },
    {
        _id: 1006,
        title: "Resume",
        link: "resume",
    },
    {
        _id: 1007,
        title: "Contact",
        link: "contact",
    },
]